import { useGo, useNavigation, useRouterType, useTranslate } from "@refinedev/core";
import { Button, Result, Space, Typography } from "antd";

const { Text } = Typography;

export const NoAccessError = () => {
  const translate = useTranslate();
  const { push } = useNavigation();
  const go = useGo();
  const routerType = useRouterType();
  return (
    <Result
      extra={
        <Space direction="vertical" size="large">
          <Space>
            <Text>{translate("pages.error.403", "Sorry, something went wrong.")}</Text>
          </Space>
          <Button
            onClick={() => {
              if (routerType === "legacy") {
                push("/");
              } else {
                go({ to: "/" });
              }
            }}
            type="primary"
          >
            {translate("pages.error.backIndex", "Refresh")}
          </Button>
        </Space>
      }
      status="403"
    />
  );
};
